import { serviceName } from '../resources/serviceConstants';
import {
  RESOURCE_ALLOCATION_DEPARTMENTS,
  RESOURCE_ALLOCATION_EXPORT,
  RESOURCE_ALLOCATION_RESOURCE,
  TBH_RESOURCE_ALLOCATION,
} from '../resources/endPoint';

export const createResourceAllocation = (payload) => ({
  url: RESOURCE_ALLOCATION_RESOURCE,
  method: 'post',
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const updateResourceAllocation = (allocationId, payload) => ({
  url: `${RESOURCE_ALLOCATION_RESOURCE}/${allocationId}`,
  method: 'put',
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const deleteResourceAllocation = (allocationId) => ({
  url: `${RESOURCE_ALLOCATION_RESOURCE}/${allocationId}`,
  method: 'delete',
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getScrums = () => ({
  url: `${RESOURCE_ALLOCATION_RESOURCE}/scrums`,
  method: 'get',
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getResourceAllocationList = (projectId) => ({
  url: `${RESOURCE_ALLOCATION_RESOURCE}?projectId=${projectId}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const exportResourceAllocation = (payload) => ({
  url: RESOURCE_ALLOCATION_EXPORT,
  method: 'post',
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getResourceAllocationProjectDetails = (projectId) => ({
  url: `${RESOURCE_ALLOCATION_RESOURCE}/project/${projectId}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getTbhResourceAllocations = (projectId, cacheBust = '') => ({
  url: `${TBH_RESOURCE_ALLOCATION}?cb=${encodeURIComponent(cacheBust)}${projectId ? `&projectId=${projectId}` : ''}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getTbhIdsList = () => ({
  url: `${RESOURCE_ALLOCATION_RESOURCE}/tbh-ids?cb=${Date.now()}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getEmployeesList = () => ({
  url: `${RESOURCE_ALLOCATION_RESOURCE}/employees`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getDepartmentsList = () => ({
  url: RESOURCE_ALLOCATION_DEPARTMENTS,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getRegionCountryMapping = () => ({
  url: `${RESOURCE_ALLOCATION_RESOURCE}/filter/region-country-mapping`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getVerticalNames = (payload) => ({
  url: `${RESOURCE_ALLOCATION_RESOURCE}/filter/vertical-names`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getExperienceLevels = () => ({
  url: `${RESOURCE_ALLOCATION_RESOURCE}/filter/experience-levels`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getLocationTypes = () => ({
  url: `${RESOURCE_ALLOCATION_RESOURCE}/filter/location-types`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const updateBulkResourceAllocation = (payload) => ({
  url: `${RESOURCE_ALLOCATION_RESOURCE}/bulk-update`,
  method: 'put',
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});
